module.exports = __webpack_public_path__ + "static/media/22.27f2ee8f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/22.mp3
// module id = 498
// module chunks = 0